export const ImageTypes: ObjectOf<string> = {
  'image/bmp': 'bmp',
  'image/gif': 'gif',
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/svg+xml': 'svg',
  'image/webp': 'webp',
  'image/heic': 'heic',
};

export const DocumentTypes: ObjectOf<string> = {
  ...ImageTypes,
  'application/msword': 'doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    'docx',
  'application/vnd.ms-excel': 'xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'application/vnd.ms-powerpoint': 'ppt',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation':
    'pptx',
  'application/pdf': 'pdf',
  'image/tiff': 'tif',
};

export const JsonType: ObjectOf<string> = {
  'application/json': 'json',
};
